import moment from 'moment';
import _ from 'lodash';
import formatCurrency from 'format-currency';
import jsPDF from "jspdf";
import $ from "jquery";
import html2canvas from 'html2canvas';

class TimesheetReportController {
  constructor($rootScope, $uibModal, $state, $http, $window) {
    "ngInject";
    this.state = $state;
    this.$http = $http;
    this.queryResult;
    this.$rootScope = $rootScope;
    this.customerFilter = 'all';
    this.contractFilter = 'all';
    this.taskFilter = 'all';
    this.timesheetYears = [];
    this.formatCurrency = formatCurrency;
    let self = this;
    this.$window = $window;
    this.$http.get($rootScope.apiHost + "/api/admin/users/names", {withCredentials: true}).then(function (success) {
      self.employees = success.data;
    });

  }

  loadTimesheets(employee) {
    let self = this;

    this.timesheetsByYear = {};

    this.$http.get(this.$rootScope.apiHost + "/api/timesheets/dates/"+employee.id, {withCredentials: true}).then(function (success) {
      success.data.forEach(function(ts) {
        let year = moment(ts.endDate).year();
        if(!self.timesheetsByYear[year]){
          self.timesheetsByYear[year] = [];
        }

        self.timesheetsByYear[year].push(ts);
      });

      self.timesheetYears = Object.keys(self.timesheetsByYear);
      self.selectedTimesheetYear = self.timesheetYears[self.timesheetYears.length -1];
      self.employeeTimesheets = self.timesheetsByYear[self.selectedTimesheetYear];
    });
  }

  getTimesheetsForYear(){
    this.employeeTimesheets = this.timesheetsByYear[this.selectedTimesheetYear];
  }

  loadTimesheet(id) {
    let self = this;
    this.$http.get(this.$rootScope.apiHost + "/api/timesheet-review/"+id, {withCredentials: true}).then(function (success) {
      self.selectedTimesheet = success.data;
    });
  }

  exportPdf() {
    this.$window.html2canvas = html2canvas;
    window.html2canvas = html2canvas;

    var doc = new jsPDF('l');

    html2canvas($('#ts123')[0]).then(function(canvas) {
      var ctx = canvas.getContext("2d");
      // ctx.scale(.5, .5);

      console.log(canvas.height);
      console.log(canvas.width);

      // var imgData = canvas.toDataURL("image/jpeg");
      // // imageData, format, x, y, w, h, alias, compression, rotation
      // doc.addImage(imgData, 'JPEG', 0, 10);
      // let x = moment().format("MMDDYYYY")
      // doc.save('timesheet'+x+'.pdf');
    });

    // doc.addHTML($('#ts123')[0], function() {

    // });

  }


}

export default TimesheetReportController;



// WEBPACK FOOTER //
// ./client/pages/admin/reports/canned-reports/timesheet-report/timesheet-report.controller.js